<template>
  <div>
    <h5 class="py-3">{{ hasSearch ? $t('select_topic') : '找不到主題'}}</h5>
    <div class="container">
      <div v-if="lessonList.data" class="row pt-3 pb-3">
        <div class="col-12 col-sm-6 col-md-3 p-1" v-for="lesson in lessonList.data" :key="lesson.id" :lang="lesson.language">
          <div class="card" style="max-width: 100%;" @click="$router.push({ name: 'c_play', params: { lessonId: lesson.id }})">
            <img class="card-img-top" :src="lesson.cover ? lesson.cover : 'https://via.placeholder.com/300x250'">
            <div class="card-body text-left" :style="{ 'letter-spacing': '2px', 'height': '120px', 'overflow-y': 'hidden' }">
              <h5 class="card-title mb-0" ></h5>
              <p class="card-text">{{ lesson.localName }}</p>
              <p class="card-text">{{ lesson.name }}</p>
            </div>
            <ul class="list-group list-group-flush ml-2 mr-2">
              <li class="border-top pl-0 pr-0 pt-3 pb-3" style="line-height: 300%; list-style: none;">
                <span class="float-left">
                  <img src="../../../assets/image/cloud/icon_video.png" height="30" v-show="lesson.tags.indexOf('video')>-1"/>
                  <img src="../../../assets/image/cloud/icon_picture_vocabulary.png" height="30" v-show="lesson.tags.indexOf('vocabulay')>-1"/>
                  <img src="../../../assets/image/cloud/icon_article.png" height="30" v-show="(lesson.tags.indexOf('sentence')>-1) && lesson.name!=='White House'"/>
                </span>
                <span class="float-right">
                  <!-- <span class="p-0 pl-3 pr-3 text-white btn-category content" v-if="lesson.language">{{ lesson.language }}</span> -->
                  <span class="p-0 pl-3 pr-3 text-white btn-category user-target" v-if="lesson.categoryName">{{ lesson.categoryName }}</span>
                  <!-- <span class="p-0 pl-3 pr-3 text-white btn-category level" v-if="lesson.level">{{ lesson.level }}</span> -->
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <pagination v-if="lessonList" :current="lessonList.pageIndex" :total="lessonList.pageCount" v-on:page="goPage" />
    </div>
  </div>
</template>

<script>
import api from '../../../store/api'
import Pagination from '../../../components/Pagination'

export default {

  name: 'ARLessons',
  components: {
    Pagination
  },
  data () {
    return {
      hasSearch: true,
      lessonList: {},
      pageSize: 12,
      resourceOptions: [
        {
          name: '教學簡報',
          title: 'Teaching PPT',
          category: 'ppt'
        },
        {
          name: '主題教案',
          title: 'Teaching Plans',
          category: 'plan'
        },
        {
          name: '複習教案',
          title: 'Review Teaching Plans',
          category: 'review'
        },
        {
          name: 'AR辨識閃卡',
          title: 'AR Flashcards',
          category: 'flashcard'
        }
      ]
    }
  },
  props: {
    inputSearchTxt: {
      type: String,
      required: false,
      default: ''
    }
  },

  computed: {
  },
  mounted () {
    this.getLesson()
  },
  watch: {
    '$route.params.page': {
      handler: function (val) {
        this.getLesson()
      },
      deep: true,
      immediate: true
    },
    inputSearchTxt (val) {
      this.goPage()
      this.getLesson()
    }
  },
  methods: {
    goPage (page = 1) {
      this.$router.push({name: 'ar_lesson', params: {page: page}})
    },
    async getLesson () {
      let params = {
        pageIndex: this.$route.params.page,
        pageSize: this.pageSize,
        searchTxt: this.inputSearchTxt
      }
      const { data } = await api.get(`/Globetrotting/Country/${this.$route.params.id}/Lesson`, { params })
      if (data.status === 'OK') {
        this.lessonList = data
        console.log(data.data)
        if (data.data.length) {
          this.hasSearch = true
        } else {
          this.hasSearch = false
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .card {
    cursor: pointer;

    .card-title {
      font-size: 16px;
    }

    .card-body {
      font-size: 14px;
    }

    &:hover {
      box-shadow: 0 0 8px #a1a1a1;
      transition: box-shadow 0.2s ease-in-out;
    }
  }
</style>



// WEBPACK FOOTER //
// Lesson.vue?d7c66346